// @ts-check
/**
 * The errors of the storage scope. The package's own errors (`NotFoundError`,
 * `ReadOnlyError`) are the package's and are imported from its index.
 *
 * @module classes/storage/storage-errors
 * @author Saleh Abdel Motaal <dev@smotaal.io>
 * @ai Claude Fable 5.1 (code generation)
 */

/**
 * The ask was made without a user activation.
 *
 * Its own class, because a caller has to be able to tell "the browser said no"
 * (an ordinary answer, reported by `helpers/persistence.js` step by step) from
 * "you asked at a moment the browsers do not consult", which is a defect in the
 * calling code and not news about the origin.
 */
export class PersistenceActivationError extends Error {
    constructor() {
        super(
            'Persistent storage was asked for without a user activation: navigator.userActivation.isActive '
            + 'is false. Every engine consults the activation, so the ask is made FROM the gesture that asks '
            + 'for it — the badge is the button.');
        this.name = 'PersistenceActivationError';
    }
}
